const GetClientAccessType = (access: server.dto.ClientAccess) => {
  switch (access.value) {
    case "unknown":
    case "activeTrial":
    case "activeFree":
    case "activePaid":
    case "activeReadOnly":
      return "active";
    case "cancelledByClient":
    case "cancelledBySystemOne":
    case "trialEnd":
      return "closed";
    case "suspendedForAbuse":
    case "suspendedForNotPaying":
      return "suspended";
    case "temporarilyOpened":
      return "temporarilyOpened";
  }
};

const GetClientAccessTypeLabel = (accessType: ClientAccessTypes) => {
  switch (accessType) {
    case "active":
      return "Suspend";
    case "closed":
      return "Allow temporary access";
    case "suspended":
      return "End account suspension";
    case "temporarilyOpened":
      return "End temporary access";
  }
};

export type ClientAccessTypes = "active" | "closed" | "suspended" | "temporarilyOpened";

export { GetClientAccessType, GetClientAccessTypeLabel };